import memoize from 'memoize-weak';

// Create a cache which keys arrays based on the shallow references of their items
const arrayCache = () => {
  const cache = memoize((...array: Array<any>) => array);
  return (array: Array<any>) => {
    return cache(...array);
  };
};

export default arrayCache;
